module.exports = __webpack_public_path__ + "media/Centrally_Manage_R2_1.b7db2e8b.mp4";